<template>
    <a-modal
        centered
        :visible="visible"
        title="取消并结束订单"
        @ok="on_submit"
        @cancel="cancel"
        :confirmLoading="submitting"
        :width="480"
        :after-close="after_close"
    >
        <a-form-model :model="form" ref="order-cancel" :rules="rules">
            <!-- <a-form-model-item label="违约金" prop="content">
                <a-input type="text" v-model="form.amount_liquidated"></a-input>
            </a-form-model-item> -->
            <a-form-model-item label="填写订单取消原因" prop="content">
                <a-textarea v-model="form.content"></a-textarea>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
    let init_form = {
        content: null,
        amount_liquidated: null,
        order_no: null,
    };
    export default {
        props: {
            visible: {
                default: false,
            },
            record: null,
            callback: null,
        },
        data() {
            return {
                submitting: false,
                rules: {
                    content: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                },
                form: null,
            };
        },
        created() {
            this.form = JSON.parse(JSON.stringify(init_form));
            // this.load_group();
            // this.load_role();
        },
        watch: {
            visible(e) {
                if (e && this.record) {
                    Object.keys(this.form).map((v) => {
                        if (Object.prototype.hasOwnProperty.call(this.record, v)) {
                            this.form[v] = this.record[v];
                        }
                    });
                }
            },
        },
        methods: {
            cancel() {
                this.$emit("close");
            },
            on_submit() {
                this.$refs["order-cancel"].validate((valid) => {
                    if (valid) {
                        this.submitting = true;
                        this.form.type = "confirm";

                        this.$http
                            .post("/order_trademark/cancel", this.form)
                            .then((res) => {
                                if (res.success) {
                                    this.cancel();
                                    this.$message.success(res.message);

                                    if (this.callback) {
                                        this.callback();
                                    }
                                } else {
                                    this.$error({ title: "失败", centered: true, content: res.message });
                                }
                            })
                            .catch(() => {})
                            .then(() => {
                                this.submitting = false;
                            });
                    } else {
                        this.$message.error("请检查并填写完需要录入的内容");
                        return false;
                    }
                });
            },

            after_close() {
                this.$refs["order-cancel"].resetFields();

                this.form = JSON.parse(JSON.stringify(init_form));
            },
        },
    };
</script>
